export function isValidDomain(domain: string): boolean {
    if (!domain) {
        return false;
    }
    const regExp = /^(?!:\/\/)([a-zA-Z0-9-]+\.){0,5}[a-zA-Z0-9-][a-zA-Z0-9-]+\.[a-zA-Z0-9-]{2,64}?$/gi;
    return regExp.test(domain);
}
